import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useTitleWithPrintStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingTop: theme.spacing(0),
        },
        title: {
            fontSize: '40px',
            lineHeight: '50px',
        },
    }),
);

export default useTitleWithPrintStyles;
